<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="container">
        <div class="text-center">
          <img
            class="mt-5 mb-3"
            src="@/assets/img/election_logo.png"
            alt="MUIC"
          />
        </div>
        <div class="row mb-5">
          <div class="col-sm-12 col-md-8 offset-md-2">
            <!-- a -->
            <b-card class="card-app-2 mt-3 mb-2">
              <b-card-title>
                <div class="align-items-center">
                  <h4 class="mt-0 font-weight-bold">
                    <i class="mr-3 fa fa-graduation-cap" aria-hidden="true"></i>
                    Graduate Profile
                  </h4>
                </div>
              </b-card-title>
              <b-card-text class="mt-5 mb-3">
                <div v-if="dataProfileGrad.length !== 0" class="pa-2">
                  <h3 class="mt-2 mb-0 font-weight-bold text-success">
                    Graduation Number :: {{ dataProfileGrad[0].present_order }}
                    <i
                      v-if="checkQr === 'present'"
                      class="text-primary ml-2 fa-lg fa fa-check-square-o"
                      aria-hidden="true"
                    ></i>
                  </h3>
                  <p class="mb-1 mt-1 text-muted font-weight-bold">
                    1st Rehearsal Schedule :
                  </p>
                  <div class="ml-2 mb-3">
                    <b-list-group>
                      <b-list-group-item class="font-weight-bold">
                        <i
                          v-if="
                            dataProfileGrad[0].present_order >= 1343 &&
                            dataProfileGrad[0].present_order <= 1601
                          "
                          class="mr-3 fa fa-map-marker"
                          aria-hidden="true"
                        ></i
                        >Graduation NO. 1343 - 1601 : 07.30 A.M. – 12.00 P.M.
                      </b-list-group-item>
                      <b-list-group-item class="font-weight-bold">
                        <i
                          v-if="
                            dataProfileGrad[0].present_order >= 1602 &&
                            dataProfileGrad[0].present_order <= 1849
                          "
                          class="mr-3 fa fa-map-marker"
                          aria-hidden="true"
                        ></i>
                        Graduation NO. 1602 - 1849 : 01.00 P.M. – 05.00 P.M.
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                  <p class="mb-1 mt-2 font-weight-bold">
                    <span class="text-muted">Name :</span>
                    {{
                      `${dataProfileGrad[0].title_en} ${dataProfileGrad[0].name_en}`
                    }}
                  </p>
                  <p class="mb-3 mt-0 font-weight-bold">
                    <span class="text-muted">Bachelor :</span>
                    {{ dataProfileGrad[0].bachelor }}
                  </p>
                  <p class="mb-3 mt-0 font-weight-bold">
                    <span class="text-muted">Major :</span>
                    {{
                      `${dataProfileGrad[0].major_en} , ${dataProfileGrad[0].major_th}`
                    }}
                  </p>
                  <div
                    v-if="
                      dataProfileGrad[0].msg !== null &&
                      dataProfileGrad[0].msg !== ''
                    "
                  >
                    <p class="mb-3 mt-0 font-weight-bold text-muted">
                      Remark :
                    </p>
                    <div
                      style="max-width: 100%"
                      class="d-inline-block ml-3 mb-3"
                    >
                      <span class="readText">{{ dataProfileGrad[0].msg }}</span>
                    </div>
                  </div>
                  <div
                    v-if="
                      dataProfileGrad[0].remark !== null &&
                      dataProfileGrad[0].remark !== ''
                    "
                  >
                    <p class="mb-3 mt-0 font-weight-bold text-muted">
                      Announcement :
                    </p>
                    <div
                      style="max-width: 100%"
                      class="d-inline-block ml-3 mb-3"
                    >
                      <span class="readText">{{
                        dataProfileGrad[0].remark
                      }}</span>
                    </div>
                  </div>
                </div>
                <!-- v-if="dataATKTest.length !== 0" -->
                <div
                  class="mt-3 mb-3 ml-3 mr-3 text-center align-items-center"
                >
                  <b-button
                    @click="modalCheckIn('open')"
                    variant="success"
                    block
                    ><span class="h5 font-weight-bold text-capitalize"
                      >Check-in</span
                    ></b-button
                  >
                </div>
                <!-- MSG ERROR -->
                <div v-if="errorMsgRes.length !== 0">
                  <!-- <pre>{{ errorMsgRes[0] }}</pre> -->
                  <b-alert class="mt-2" show variant="danger-cus">
                    <h5 class="text-dark font-en-chk font-weight-bold mb-1">
                      Problem request data Graduate Profile !
                    </h5>
                    <hr class="bg-dark" />
                    <p class="mt-0 mb-0">
                      Please contact
                      <strong class="text-primary"
                        >The Office of Student Affairs (MUIC)</strong
                      >
                    </p>
                    <p class="mt-0 mb-0">
                      E-mail
                      <strong class="text-primary"
                        >address: icsa@mahidol.ac.th</strong
                      >
                    </p>
                    <p class="mt-0 mb-0">
                      Phone:
                      <strong class="text-primary"
                        >02-700-5000 ext.1120, 1115 or 1242 Fax
                        02-441-0966</strong
                      >
                    </p>
                  </b-alert>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </div>
        <!-- modal sucess -->
        <b-modal
          centered
          ref="bv-modal-sucess"
          id="bv-modal-sucess"
          hide-footer
          hide-header-close
          no-close-on-backdrop
        >
          <template v-slot:modal-title>
            <h5 class="font-en mt-2 mb-0">Atk form</h5>
          </template>
          <div>
            <b-alert show variant="success">
              <p class="mt-1 mb-1 font-en">Completed</p>
            </b-alert>
          </div>
          <b-button
            size="sm"
            class="mt-2 mb-2 font-en"
            @click="closeModal"
            block
            variant="link"
            ><u>Close Pop-up</u></b-button
          >
        </b-modal>
        <!-- modal sucess -->
        <!-- modal check-in -->
        <b-modal
          centered
          ref="bv-modal-infoma"
          id="bv-modal-infoma"
          hide-footer
          no-close-on-backdrop
        >
          <template v-slot:modal-title>
            <h5 class="font-en mt-2 mb-0 font-weight-bold">- QR CODE -</h5>
          </template>
          <!--  v-if="dataATKTest.length !== 0" -->
          <b-card>
            <div class="text-center mb-3 mt-2">
              <h2 class="mt-0 mb-2 font-weight-bold">
                {{ currentTime }}
              </h2>
              <qrcode
                v-if="checkQr !== 'present'"
                class="mt-0 text-center"
                :value="encodeURI($keycloak.userName.split('u')[1])"
                :options="{ width: WidthQr }"
              ></qrcode>
              <div class="mt-5 mb-5" v-else>
                <i
                  style="font-size: 100px; margin-left: -70px"
                  class="text-primary fa fa-check-square-o"
                  aria-hidden="true"
                ></i>
              </div>
              <h6 class="mt-0 mb-3 font-weight-bold">
                {{ code
                }}<strong>{{ $keycloak.userName.split("u")[1] }}</strong>
              </h6>
            </div>
            <b-list-group v-if="dataProfileGrad.length !== 0">
              <!-- <pre>{{ dataProfileGrad[0] }}</pre> -->
              <b-list-group-item>
                <h5 class="mt-2 mb-0 font-weight-bold text-muted">
                  Your graduation number is :
                </h5>
                <h2 class="mt-0 mb-0 font-weight-bold text-success">
                  {{ dataProfileGrad[0].present_order }}
                </h2>
              </b-list-group-item>
              <b-list-group-item class="text-center">
                <p class="mb-0 mt-0 font-weight-bold text-danger">
                  Please use this QR Code for the registration
                </p>
                <!-- <p class="mb-0 mt-0 font-weight-bold text-danger">
                  on 20 September 2022 (1st Rehearsal).
                </p> -->
              </b-list-group-item>
            </b-list-group>
            <!-- list - submit -->
            <!--  

              <h6 class="mt-4 mb-2 font-weight-bold text-danger">
                History of ATK Submission
              </h6>
              <b-list-group class="mt-2" flush>
                <b-list-group-item
                  v-for="(item, index) in dataATKTest"
                  :key="'line' + index"
                >
                  <b-card-text class="mb-0 f-12">
                    <strong>
                      <span class="text-muted mr-2"
                        >{{ index + 1 }}. ATK Test Date ::</span
                      >{{ moment(item.check_date).format("DD/MM/YYYY") }}
                    </strong>
                  </b-card-text>
                </b-list-group-item>
              </b-list-group>

            -->
          </b-card>
          <b-button
            size="sm"
            class="mt-2 mb-2 text-primary font-en"
            @click="modalCheckIn('close')"
            block
            variant="link"
            ><u>Close Pop-up</u></b-button
          >
        </b-modal>
        <!-- modal check-in -->
      </div>
    </div>
  </div>
</template>

<script>
const validateEmail = (email) => {
  //eslint-disable-next-line
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
const formAtk = {
  typeAtk: "",
  fileUpload: null,
  dateCheck: new Date(),
};
export default {
  data() {
    return {
      RegExNum: new RegExp(/^[0-9]+$/),
      SendForm: Object.assign({}, formAtk),
      Msg: Object.assign({}, {}),
      btnLoading: false,
      // msg consent
      consent: "not_accepted",
      consent_2: "not_accepted",
      text_1:
        "I consent to MUIC handling my medical information that \
        I have submitted in this form for the purpose described above. \
        The medical information will not be shared outside of MUIC under any circumstances. \
        ข้าพเจ้ารับทราบและอนุญาตให้วิทยาลัยเก็บรักษาข้อมูลนี้เพื่อจุดประสงค์ข้างต้นเท่านั้นและวิทยาลัยจะไม่เปิดเผยข้อมูลให้แก่บุคคลอื่นในทุกกรณี",
      text_2:
        "I certify that the information in this form and any attached files is true and correct. \
        I understand that I must take full responsibility for the consequences of any false \
        information submitted and that MUIC will not be held liable for any false information. \
        ข้าพเจ้ายืนยันว่าข้อมูลนี้เป็นความจริงทุกประการ ถ้าข้าพเจ้าให้ข้อมูลที่เป็นเท็จและทำให้เกิดความเสียหายขึ้น \
        ข้าพเจ้าจะรับผิดชอบความเสียหายเหล่านั้นทั้งหมดเองและทางวิทยาลัยจะไม่รับผิดชอบแต่อย่างใด",
      masks: {
        input: "DD/MM/YYYY",
      },
      minDay: "",
      // log send
      dataATKTest: [],
      dataProfileGrad: [],
      dataPeriod: [],
      errorMsgRes: [],
      WidthQr: "300",
      // time
      currentTime: null,
      // polling
      checkQr: "",
      polling: null,
    };
  },
  destroyed() {
    if (this.polling) {
      clearInterval(this.polling);
    }
  },
  created() {
    this.currentTime = this.moment().format("LTS");
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  },
  computed: {
    formOpenValid() {},
  },
  mounted() {
    this.randomCod();
    this.beforeDate();
    this.getGradProfile();
    this.getAtkTest();
  },
  methods: {
    modalCheckIn(typeAction) {
      if (typeAction === "open") {
        this.$refs["bv-modal-infoma"].show();
        this.pollData();
      } else {
        this.$refs["bv-modal-infoma"].hide();
        if (this.polling) {
          clearInterval(this.polling);
        }
      }
    },
    // other func
    randomCod() {
      this.code = "";
      let chars = "abcdefghijlmnopqrstuvxwz";
      let numbers = "0123456789";
      let specialCaracter = "0123456789";
      for (let i = 4; i > 1; i--) {
        let random = Math.floor(Math.random() * 99999).toString();
        this.code +=
          specialCaracter[random.substring(i, i - 1)] +
          (parseInt(random.substring(i, i - 1)) % 2 == 0
            ? chars[random.substring(i, i - 1)].toUpperCase()
            : chars[random.substring(i, i + 1)]) +
          numbers[random.substring(i, i - 1)];
      }
      this.code =
        this.code.indexOf("undefined") > -1 || this.code.indexOf("NaN") > -1
          ? this.randomCod()
          : this.code;
      return this.code;
    },
    // Date check
    diffDayOpen(chkTime, da, db) {
      if (chkTime !== "" && da !== "") {
        if (!this.moment(db).isAfter(da)) {
          if (this.moment(db).isBefore(da)) {
            return false;
          } else {
            if (!this.DayAnounResult(chkTime)) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          if (this.moment(db).isSame(da)) {
            if (!this.DayAnounResult(chkTime)) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    diffOpenForm(setTime, setExp, nowDate) {
      if (setTime !== "" && setExp !== "") {
        if (this.moment(setExp).isBefore(nowDate)) {
          return false;
        } else {
          if (this.moment(setExp).isSame(nowDate)) {
            if (!this.DayAnounResult(setTime)) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    DayAnounResult(TimeShow) {
      if (TimeShow !== "" && TimeShow !== null) {
        let ts = this.moment().format();
        let d = this.moment().utc(ts);
        let time = TimeShow;
        let [h, m] = time.split(":");
        let e = d.clone().hours(h).minutes(m).seconds(0).milliseconds(0);
        return d.isBefore(e);
      } else {
        return true;
      }
    },
    // other func
    updateCurrentTime() {
      this.currentTime = this.moment().format("LTS");
    },
    beforeDate() {
      let yesterday = new Date(this.SendForm.dateCheck.getTime());
      this.minDay = new Date(
        yesterday.setDate(this.SendForm.dateCheck.getDate() - 6)
      );
    },
    closeModal() {
      this.$refs["bv-modal-sucess"].hide();
    },
    confirmSend() {
      this.$refs["bv-modal-sucess"].show();
    },
    getFileExtension(filename) {
      // console.log(filename); "application/pdf",
      if (filename) {
        return ["image/jpg", "image/jpeg", ".heic", "image/png"].includes(
          filename.type
        );
      }
    },
    async getAtkTestPolling() {
      try {
        const res = await this.$http.get(`/graduate-atk/profile/me/`);
        if (res.status === 200) {
          if (res.data.user.practise === "present") {
            // this.modalCheckIn('close')
            this.checkQr = "present";
          }
        } else if (res.status === 204) {
          // this.errorMsgRes.push("No content Profile");
        } else {
          throw { res };
        }
      } catch (error) {}
    },
    async getGradProfile() {
      this.dataPeriod = [];
      this.dataProfileGrad = [];
      this.errorMsgRes = [];
      try {
        const res = await this.$http.get(`/graduate-atk/profile/me/`);
        if (res.status === 200) {
          this.dataPeriod.push(res.data.date_check);
          this.dataProfileGrad.push(res.data.user);
          if (res.data.user.practise === "present") {
            this.checkQr = "present";
          } else {
            this.checkQr = "";
          }
        } else if (res.status === 204) {
          this.errorMsgRes.push("No content Profile");
        } else {
          throw { res };
        }
      } catch (error) {
        this.errorMsgRes.push(error);
        this.dataProfileGrad = [];
        this.dataPeriod = [];
      }
    },
    async getAtkTest() {
      this.dataATKTest = [];
      try {
        const res = await this.$http.get(`/graduate-atk/check-atk/me/`);
        if (res.status === 200) {
          let a = 1;
          this.dataATKTest = res.data.map((item) => ({
            no: a++,
            ...item,
            exprise: this.moment(
              this.moment(item.check_date).format("YYYY-MM-DD")
            )
              .add(7, "days")
              .format("DD / MMMM / YYYY"),
          }));
        } else {
          throw { res };
        }
      } catch (error) {
        this.dataATKTest = [];
      }
    },
    async submitTestKit() {
      Object.assign(this.Msg, {});
      this.btnLoading = true;
      if (this.getFileExtension(this.SendForm.fileUpload)) {
        const sendformData = new FormData();
        sendformData.append("file_img", this.SendForm.fileUpload);
        sendformData.append(
          "check_date",
          this.moment(this.SendForm.dateCheck).format("YYYY-MM-DD")
        );
        try {
          const resFormAtk = await this.$http.post(
            "/graduate-atk/check-atk/add_data/",
            sendformData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          if (resFormAtk.status === 201) {
            this.btnLoading = false;
            this.SendForm = Object.assign({}, formAtk);
            this.consent = "not_accepted";
            this.consent_2 = "not_accepted";
            this.confirmSend();
            this.getAtkTest();
          } else {
            throw { resFormAtk };
          }
        } catch (error) {
          // console.log(error)
          this.btnLoading = false;
          Object.assign(this.Msg, {
            text: `Caught API : /graduate-atk/check-atk/add_data/ : ${error.resFormAtk.data.error}`,
            view: true,
          });
        }
      } else {
        this.btnLoading = false;
        Object.assign(this.Msg, {
          text: "Caught File upload Error : image Only",
          view: true,
        });
      }
    },
    // polling
    pollData() {
      this.polling = setInterval(async () => {
        if (this.checkQr !== "present") {
          await this.getAtkTestPolling();
        }
      }, 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
.readText {
  max-width: 250px;
  white-space: pre-line;
}
.font-en {
  font-family: "Rubik", sans-serif;
  font-size: 1rem;
  font-weight: 300;
}
.font-eng {
  font-family: "Rubik", sans-serif;
}
.card-app {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 10px;
}
.card-app-2 {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 10px;
  font-weight: 500;
  border: 2px solid #ece1fd;
  opacity: 10;
  background-image: url("../../assets/img/grd.png");
}
.text-title-consent {
  font-size: 16px;
  font-weight: 700;
}
.input-custom {
  border: 1px solid #d2d0d0;
}
.alert-success {
  background-color: #caffe7;
  color: #229863;
}
.alert-danger-cus {
  background-color: #fcd6d9;
  color: #000000;
}
.bg-op {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../../assets/img/bg-ticket.png");
}
.text-su {
  color: #00a7ab;
}
.text-sha {
  text-shadow: 0px 3px 0px #b2a98f, 0px 14px 10px rgba(0, 0, 0, 0.15),
    0px 7px 2px rgba(0, 0, 0, 0.1), 0px 34px 30px rgba(0, 0, 0, 0.1);
  font-size: 3rem;
}
// ticket
.ticket {
  padding-top: 52%;
  background-color: #000000;
  border-radius: 20px;
  margin-top: 100px;
  position: relative;
  overflow: hidden;
  z-index: 0;
}
.ticket::before {
  content: "";
  padding-top: 74%;
  padding-left: 74%;
  // background-color: #562361;
  position: absolute;
  border-radius: 50%;
  top: -20%;
  right: -42%;
  z-index: -1;
}
.tear-line {
  padding-right: 17%;
  height: 100%;
  float: right;
  border-left: 1px dashed white;
  position: absolute;
  top: 0;
  right: 0;
}
.tear-line::before {
  content: "";
  width: 18%;
  height: 6%;
  background-color: black;
  z-index: 1;
  border-radius: 50%;
  top: -3%;
  left: -10%;
  position: absolute;
}
.tear-line::after {
  content: "";
  width: 18%;
  height: 6%;
  background-color: black;
  z-index: 1;
  border-radius: 50%;
  bottom: -3%;
  left: -9%;
  position: absolute;
}
.hole {
  content: "";
  width: 17%;
  height: 22%;
  background-color: #ffffff;
  border-radius: 20px;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 15%;
  z-index: -1;
}
.hole::before {
  content: "";
  width: 100%;
  padding-top: 100%;
  // background-color:  #ffffff;
  position: absolute;
  border-radius: 50%;
  bottom: -11%;
  z-index: -1;
}
.hole::after {
  content: "";
  width: 100%;
  padding-top: 100%;
  // background-color:  #ffffff;
  position: absolute;
  border-radius: 20px;
  top: -11%;
  z-index: -1;
}
.xxxxxx {
  font-family: "Rubik", sans-serif;
  font-size: 50px;
  // text-transform: uppercase;
  position: absolute;
  top: 7%;
  color: #00a7ab;
  left: 7%;
  font-weight: 100;
}
.f-t-1 {
  font-size: 2rem;
}
.f-sur-1 {
  font-size: 2rem;
}
.widt-trun {
  max-width: 400px;
}
.mark-font {
  font-weight: bold;
  color: #fff;
  font-size: 2.5rem;
  text-shadow: 5px 5px 0 #00a8ac, 5px 5px 0 #00a8ac, 5px 1.5px 0 #00a8ac,
    5px 2px 0 #00a8ac, 5px 2.5px 0 #00a8ac, 0 6px 1px rgba(0, 0, 0, 0.1),
    0 0 5px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.3),
    0 3px 5px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.25),
    0 10px 10px rgba(0, 0, 0, 0.2), 0 20px 20px rgba(0, 0, 0, 0.15),
    /* 14px 0 14px #ea175a, 
        10px 0 10px #ea175a,
        3px 0 3px #ea175a,
        4px 0 4px #ea175a,
        5px 0 5px #ea175a; */ -5px -5px
      0 #e9175a,
    -5px -5px 0 #e9175a, -5px -1.5px 0 #e9175a, -5px -2px 0 #e9175a,
    -5px -2.5px 0 #e9175a;
}
.content-blur {
  backdrop-filter: blur(3px);
  padding: 5px;
  width: 404px;
}
// for small screen
// for mobile
@media only screen and (max-width: 768px) {
  .widt-trun {
    max-width: 250px;
  }
  .ticket {
    padding-top: 106%;
    background-color: #000;
    border-radius: 20px;
    margin-top: 100px;
    position: relative;
    overflow: hidden;
    z-index: 0;
  }
  .ticket::before {
    content: "";
    padding-top: 103%;
    padding-left: 74%;
    // background-color: #562361;
    position: absolute;
    border-radius: 50%;
    top: -20%;
    right: -42%;
    z-index: -1;
  }
  .content-blur {
    backdrop-filter: blur(3px);
    padding: 5px;
    width: auto;
    border-radius: 10px;
  }
  .xxxxxx {
    font-family: "Rubik", sans-serif;
    font-size: 30px;
    // text-transform: uppercase;
    position: absolute;
    top: 0%;
    color: #00a7ab;
    left: 7%;
    font-weight: 100;
  }
  .f-t-1 {
    font-size: 1.2rem;
  }
  .hr-hide {
    visibility: hidden;
  }
  .f-sur-1 {
    font-size: 1.5rem;
  }
}
@media only screen and (max-width: 959px) {
  .widt-trun {
    max-width: 280px;
  }
  .ticket {
    padding-top: 79%;
    background-color: #000;
    border-radius: 20px;
    margin-top: 100px;
    position: relative;
    overflow: hidden;
    z-index: 0;
  }
  .content-blur {
    backdrop-filter: blur(3px);
    padding: 5px;
    width: auto;
    border-radius: 10px;
  }
  .f-sur-1 {
    font-size: 1.5rem;
  }
}
@media only screen and (max-width: 1200px) {
  .widt-trun {
    max-width: 150px;
  }
  .ticket {
    padding-top: 100%;
    background-color: #000;
    border-radius: 20px;
    margin-top: 100px;
    position: relative;
    overflow: hidden;
    z-index: 0;
  }
}
// for ipad
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
  .widt-trun {
    max-width: 500px;
  }
  .ticket {
    padding-top: 56%;
    background-color: #000;
    border-radius: 20px;
    margin-top: 100px;
    position: relative;
    overflow: hidden;
    z-index: 0;
  }
  .ticket::before {
    content: "";
    padding-top: 75%;
    padding-left: 74%;
    // background-color: #562361;
    position: absolute;
    border-radius: 50%;
    top: -20%;
    right: -42%;
    z-index: -1;
  }
  .content-blur {
    backdrop-filter: blur(3px);
    padding: 5px;
    width: auto;
    height: 175px;
    border-radius: 20px;
  }
  .f-sur-1 {
    font-size: 1.5rem;
  }
}
</style>